import { database } from "../firebase";
import { ref, onValue, update, get, child } from "firebase/database";

const getRecordPath = (userID, uniqueKey) => `data/scans/${userID}/${uniqueKey}`;
const getTempPath = (userID, uniqueKey) => `data/temp/${userID}/${uniqueKey}`;

export function subscribeToAddress(userID, uniqueKey, callback) {
  const addressRef = ref(database, `${getRecordPath(userID, uniqueKey)}/googleMapAddress`);
  const unsubscribe = onValue(addressRef, (snap) => callback(snap.val()));
  return () => { unsubscribe(); };
}

export function subscribeToRecord(userID, uniqueKey, callback) {
  const parentRef = ref(database, getRecordPath(userID, uniqueKey));
  const unsubscribe = onValue(parentRef, (snap) => callback(snap.val()));
  return () => { unsubscribe(); };
}

export async function checkImageExists(userID, uniqueKey) {
  const parentRef = ref(database, getRecordPath(userID, uniqueKey));
  const imageSnapshot = await get(child(parentRef, "urlToReadImage"));
  return imageSnapshot.exists() && !!imageSnapshot.val();
}

export async function writeAddedToMauticFalse(userID, uniqueKey, fields = {}) {
  const parentRef = ref(database, getRecordPath(userID, uniqueKey));
  const payload = { ...fields, addedToMautic: false, uspsValidationPending: true, uspsValidationError: null };
  return update(parentRef, payload);
}

export async function getTempRecord(userID, uniqueKey) {
  const tempRecordRef = ref(database, getTempPath(userID, uniqueKey));
  const tempSnap = await get(tempRecordRef);
  if (tempSnap.exists()) {
    return tempSnap.val();
  }
  return null;
}
